import { createFileRoute } from '@tanstack/react-router';

import { SignedOutScreen } from '../features/auth/signed-out-screen.js';

export const Route = createFileRoute('/signed-out')({
  component: SignedOutScreen,
});
